// src/pages/.../RecommendedArticleListWideSection.jsx
import React, { useEffect, useState, useMemo } from "react";

// 🔥 Firestore
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
} from "firebase/firestore";
import { db } from "../../../shared/libs/firebaseConfig";

import { Spinner } from "react-bootstrap";
import { BsChatSquareHeart } from "react-icons/bs";
import RecommendedArticleListWide from "../../articles/components/RecommendedArticleListWide";



// ---- helper: รูป fallback ----
function getFirstImageSrc(contentBlocks = []) {
  const imgBlock = contentBlocks.find((b) => b.type === "image" && b.src);
  return imgBlock?.src || "https://placehold.co/1000x650/png";
}

export default function RecommendedArticleListWideSection() {
  const [allArticles, setAllArticles] = useState([]);
  const [visibleCount, setVisibleCount] = useState(4); // แสดงเริ่มต้น 4 บทความ
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchArticles = async () => {
      try {
    

const q = query(
  collection(db, "articles"),
  where("publicStatus", "==", true),
  where("status", "==", "published"),
  where("views", ">", 0),
  orderBy("createdAt", "desc"),
  limit(50)
);

const snap = await getDocs(q);

let list = snap.docs.map((doc) => {
  const data = doc.data();

  const views = data.views ?? 0;
  const aiChatOpenCount = data.aiChatOpenCount ?? 0;
  const aiChatRatio = views > 0 ? aiChatOpenCount / views : 0;

  return {
    id: doc.id,
    slug: data.slug || doc.id,
    title: data.title || "(ไม่มีชื่อบทความ)",
    subtitle: data.subtitle || "",
    cover: data.cover || getFirstImageSrc(data.contentBlocks),
    category: data.category || { name: "ทั่วไป" },
    level: data.level || data.levelDisplay || "general",
    createdAt: data.createdAt || null,
    readTime: typeof data.readTime === "number" ? data.readTime : null,
    views,
    aiChatOpenCount,
    aiChatRatio,
  };
});

// ✨ จัดอันดับตาม aiChatRatio (มาก → น้อย)
// + กัน views น้อย ๆ ด้วย
list = list
  .filter(a => a.views >= 10)           // อยากกำหนดขั้นต่ำเท่าไหร่ก็ปรับได้
  .sort((a, b) => b.aiChatRatio - a.aiChatRatio);

        setAllArticles(list);
      } catch (err) {
        console.error(err);
        setError("ไม่สามารถโหลดบทความที่คุณอาจสนใจได้");
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  // บทความที่จะแสดงจริงตาม visibleCount
  const visibleArticles = useMemo(
    () => allArticles.slice(0, visibleCount),
    [allArticles, visibleCount]
  );

  const noMoreArticles =
    visibleCount >= allArticles.length || allArticles.length === 0;

  const handleLoadMore = () => {
    // โหลดเพิ่มครั้งละ 4 บทความ
    setVisibleCount((prev) => prev + 4);
  };

  return (
    <div className="mt-4 mb-4">
      {/* ส่วนหัว (จะมีก็ได้ ไม่มีก็ได้ ถ้าไม่ต้องการ ลบออกได้เลย) */}
      <h3>
        <strong>
          <BsChatSquareHeart /> บทความที่คุณอาจสนใจ
        </strong>
      </h3>
      {/* <p className="text-muted">
        แนะนำบทความน่าสนใจเกี่ยวกับ AI, Automation และหัวข้อที่ใกล้เคียง
      </p> */}

      {/* โหลดอยู่ */}
      {loading && (
        <div className="text-center my-4">
          <Spinner animation="border" role="status" />
        </div>
      )}

      {/* error */}
      {error && !loading && (
        <div className="text-danger my-3">{error}</div>
      )}

      {/* แสดงรายการบทความแบบ grid 2 คอลัมน์ (บนจอใหญ่) / 1 คอลัมน์ (จอเล็ก) */}
      {!loading && !error && visibleArticles.length > 0 && (
        <>
          <RecommendedArticleListWide articles={visibleArticles} />

          {/* ลิงก์โหลดเพิ่ม / ไม่มีบทความเพิ่มเติม */}
          <div className="mt-4 mb-2 text-start">
            {noMoreArticles ? (
              <span style={{ color: "#777", fontSize: "18px" }}>
                ไม่มีบทความเพิ่มเติม
              </span>
            ) : (
              <span
                onClick={handleLoadMore}
                className="load-more-link"
              >
                ดูบทความเพิ่มเติม
              </span>
            )}
          </div>

        </>
      )}

      {/* กรณีไม่มีบทความเลย (แต่ไม่ error และไม่ loading) */}
      {!loading && !error && visibleArticles.length === 0 && (
        <div className="text-muted my-3">
          ยังไม่มีบทความที่แนะนำในขณะนี้
        </div>
      )}
    </div>
  );
}
